export const moduleMixins = {
  methods: {
    // Helper method to add hover color from navigation config
    addHoverColorToStyles(styles) {
      const navigationConfig =
        this.navigationGlobal && this.navigationGlobal.config;
      const hoverColor =
        navigationConfig &&
        navigationConfig.general &&
        navigationConfig.general.hoverColor &&
        navigationConfig.general.hoverColor.value;

      if (hoverColor) {
        styles["--cr-navigation-hover-color"] = hoverColor;
      }

      return styles;
    },
  },
  computed: {
    ctaButtonElStyles() {
      // Default navigation button styling
      const navigationConfig =
        this.navigationGlobal && this.navigationGlobal.config;
      const { corners, fillStyle, backgroundColor, textColor } =
        (navigationConfig && navigationConfig.ctaButton) || {};

      if (!corners || !fillStyle || !backgroundColor || !textColor) {
        return {};
      }

      // fill styles
      let bgColorBorderColorVars = {};
      if (fillStyle.value === "fill") {
        bgColorBorderColorVars["--cr-navigation-cta-background-color"] =
          backgroundColor.value;
        bgColorBorderColorVars["--cr-navigation-cta-border"] =
          "2px solid transparent";
      } else if (fillStyle.value === "border") {
        bgColorBorderColorVars["--cr-navigation-cta-background-color"] =
          "transparent";
        bgColorBorderColorVars[
          "--cr-navigation-cta-border"
        ] = `2px solid ${backgroundColor.value}`;
      }

      // direct styles
      const styles = {
        "--cr-navigation-cta-color": textColor.value,
        borderRadius: corners.value === "round" ? "50px" : 0,
        ...bgColorBorderColorVars,
      };

      // Add hover color from navigation config
      this.addHoverColorToStyles(styles);

      return styles;
    },

    ctaButtonElStylesPitchYou() {
      // Check if custom colors should be used
      const moduleConfig = this.module && this.module.config;
      const pitchYouButton = moduleConfig && moduleConfig.pitchYouButton;
      if (pitchYouButton && pitchYouButton.useCustomColor) {
        // Use custom colors from the pitchYouButton config
        const { corners, fillStyle, backgroundColor, textColor } =
          pitchYouButton;

        // fill styles
        let bgColorBorderColorVars = {};
        if (fillStyle.value === "fill") {
          bgColorBorderColorVars["--cr-navigation-cta-background-color"] =
            backgroundColor.value;
          bgColorBorderColorVars["--cr-navigation-cta-border"] =
            "2px solid transparent";
        } else if (fillStyle.value === "border") {
          bgColorBorderColorVars["--cr-navigation-cta-background-color"] =
            "transparent";
          bgColorBorderColorVars[
            "--cr-navigation-cta-border"
          ] = `2px solid ${backgroundColor.value}`;
        }

        // direct styles
        const styles = {
          "--cr-navigation-cta-color": textColor.value,
          borderRadius: corners.value === "round" ? "50px" : 0,
          ...bgColorBorderColorVars,
        };

        // Add hover color from navigation config
        this.addHoverColorToStyles(styles);

        return styles;
      }

      // Default WhatsApp green styling
      const styles = {
        "--cr-navigation-cta-color": "#ffffff",
        "--cr-navigation-cta-background-color": "#25D366",
        "--cr-navigation-cta-border": "2px solid transparent",
        borderRadius: "50px",
      };

      // Add hover color from navigation config
      this.addHoverColorToStyles(styles);

      return styles;
    },
  },
};
